// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { createAction } from 'redux-actions';
import i18n from 'i18next';
import * as Bowser from 'bowser';

import FeedbackDal from './../../../dal/FeedbackDal';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import { userInfoSelector } from './../../../store/user';

export const saveUserFeedback = createAction('SAVE_USER_FEEDBACK');

export interface FeedbackData {
    type: string;
    title: string;
    details?: string;
    screenshot?: File;
}

function* saveUserFeedbackSaga(data: any): IterableIterator<any> {
    const payload: FeedbackData = data.payload;
    
    yield put(actionStatusStarted({ actionName: saveUserFeedback.toString() }));
    
    const agentInfo: any = yield select(state => userInfoSelector(state));
    const storeData: any = yield select();
    const browser = Bowser.getParser(window.navigator.userAgent);

    try {
        const request = {
            ...payload,
            AgentEmail: agentInfo.email,
            UserSessionData: JSON.stringify(storeData),
            RetailUserId: agentInfo.retailUserId,
            TierName: agentInfo.tierName,
            SoldTo: agentInfo.soldToCustomerNbr,
            ShipTo: agentInfo.shiptoCustomerNbr,
            BrowserLocale: navigator.language,
            SelectedLanguage: i18n.language,
            BrowserName: browser.getBrowserName(),
            BrowserVersion: browser.getBrowserVersion(),
        };

        const response = yield call(FeedbackDal.saveUserFeedback, request);
        yield put(
            actionStatusSuccess({
                actionName: saveUserFeedback.toString(),
                data: response,
            })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: saveUserFeedback.toString(),
                data: {
                    ...e,
                },
                error: new Error('Internal Error'), // TODO: Is this really a need? Can we use e? 
            })
        );
    }
}

export default [takeLatest(`${saveUserFeedback}`, saveUserFeedbackSaga)];
